module.exports = __webpack_public_path__ + "img/banner-small-min.acc29f2a.png";